export default __webpack_public_path__ + "static/media/blackGcp.4dbb71fc.svg";